import { render, staticRenderFns } from "./TopQuestion.vue?vue&type=template&id=5aac1858&scoped=true"
import script from "./TopQuestion.vue?vue&type=script&lang=js"
export * from "./TopQuestion.vue?vue&type=script&lang=js"
import style0 from "./TopQuestion.vue?vue&type=style&index=0&id=5aac1858&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aac1858",
  null
  
)

export default component.exports